import { AvailableProposal } from "src/types/loan-application";

export default function useMockHpProposal(price: number, apr?: number) {
  const proposal = {} as AvailableProposal;

  proposal.proposalId = Number(20202);
  proposal.lenderReference = 'DUMMY_REF';
  proposal.isPrime = false;
  proposal.isPreferredAcceptance = true;
  proposal.minVehicleAgeAtStart = null;
  proposal.maxVehicleAgeAtStart = 12;
  proposal.maxVehicleAgeAtEnd = 15;
  proposal.minMileage = null;
  proposal.maxMileage = Number(120000);
  proposal.maxLendAmount = Number(1000000);
  proposal.minLendAmount = Number(2000);
  proposal.minTerm = Number(24);
  proposal.maxTerm = Number(60);
  proposal.loanProposalStatus = "ProvisionalAcceptance";
  proposal.amountToFinance = Number(price);
  proposal.apr = apr ? apr : null;
  proposal.flatRate = null;

  proposal.financeCompany = 'Car Finance 247';
  proposal.financeCompanyId = 49;
  proposal.tierId = 0;

  proposal.rank = null;

  return proposal;
}
